import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "rig-mian-2"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://m.sporttery.cn/mjc/jsq/zqspf/",
  width: "100%",
  height: "100%",
  allowtransparency: "true",
  scrolling: "yes",
  frameborder: "0"
}, null, -1);
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}